import styled from "@emotion/styled";

export const StyledCashBoxes = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;
